import { isAccordionItemDefined } from './isAccordionItemDefined';
import { IAccordionItem, IAccordionBlock } from './types';

export function isAnyAccordionItemDefined(blockData: IAccordionBlock) {
  return blockData?.spoilers?.some((sp: IAccordionItem) => isAccordionItemDefined(sp));
}
